import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import ViewScore from '../components/MT_Score/ViewScore'

const MtScoreViewScore = () => {
  return (
    <>
    <Navbar />
    <ViewScore />
    </>
  )
}

export default MtScoreViewScore